import RiskListPage from "./risk-list-page.jsx";

export default RiskListPage;